import { AppContext, Features } from "@lightspeed-invoicing/core-client/frontend";
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import CostListingLabel from "../../../product/components/StockDocumentCostListingLabel.tsx";
import PriceListingLabel from "../../../product/pricelistinglabel.component.jsx";
import { Settings, SupportedSettings } from "../../../settings/account/Settings.jsx";
import { InventoryLocationAction } from "../../../state/inventory/location/actions";
import { InventoryLocationSelector } from "../../../state/inventory/location/selectors";
import { PRODUCT_TYPE } from "../../../state/product/Types";
import { INVENTORY_STOCK_DIRECTION } from "../../../utils/inventory";
import {
    getInventoryLocationFromLocation,
    getQuantityAvailableByInventoryLocationId,
    getRemoteQuantityAvailableByInventoryLocationId,
} from "../../../utils/inventory/utils";
import GlobalHelper from "../../GlobalHelper.jsx";
import Icon from "../../icon/icon.component.jsx";
import Image from "../../image/image.component.jsx";
import StandardList from "../../listing/list.component.jsx";
class ModalSearchProductList extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            selectedProductId: '',
            inventoryEnabled: GlobalHelper.isQBOInventorySyncVisible(AppContext.hasFeatureIntegration(Features.InventorySync)),
            location: this.props.location,
            selectable: this.props.selectable || false,
            totalItemsCount: this.props.totalItemsCount || 0,
            currentProductIds: this.props.currentProductIds || [],
            stockDocument: this.props.stockDocument || null,
        }

    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            headers: nextProps.products.length > 0 ? this.headers() : [],
            rows: nextProps.products.map(p => this.row(p)),
            totalItemsCount: nextProps.totalItemsCount || 0,
            pageSize: nextProps.pageSize || 10,
            currentProductIds: nextProps.currentProductIds || [],
        }, () => {
            this.setState({
                rows: this.props.products.map(p => this.row(p)),
            })
        })
    }


    componentDidMount() {
        if (this.qmInventoryEnabled()) {
            this.props.dispatch(InventoryLocationAction.fetchListing())
        }
        this.setState({
            headers: this.props.products.length > 0 ? this.headers() : [],
            rows: this.props.products.map(p => this.row(p)),
        })
    }

    addProduct(productId) {
        return (e) => {
            this.props.onProductClick(productId)
            this.props.addProductCallback(productId)
            e.preventDefault()
        }
    }

    headers() {
        const headers = [
            <FormattedMessage
                id="add_item_modal.products.list.headers.image_label"
                defaultMessage="Image"
            />,
            <FormattedMessage
                id="add_item_modal.products.list.headers.title_label"
                defaultMessage="Name"
            />,
        ]
        if (!this.state.stockDocument) {
            headers.push(<FormattedMessage
                id="add_item_modal.products.list.headers.price_label"
                defaultMessage="Price"
            />,)
        } else {
            if (this.state.stockDocument.definition.attributes.direction == INVENTORY_STOCK_DIRECTION.OUT) {
                headers.push(<FormattedMessage
                    id="add_item_modal.products.list.headers.price_label_out_cost"
                    defaultMessage="Estimated cost"
                />,)
            } else {
                headers.push(<FormattedMessage
                    id="add_item_modal.products.list.headers.price_label_in_cost"
                    defaultMessage="Cost"
                />,)
            }
        }
        if (this.state.inventoryEnabled || this.qmInventoryEnabled() || this.state.stockDocument) {
            headers.push(<FormattedMessage
                id="add_item_modal.products.list.headers.inventory_label"
                defaultMessage="Inventory"
            />)
        }
        headers.push('')
        return headers
    }

    qmInventoryEnabled() {
        return AppContext.isInventoryEnabled()
    }

    row(product) {
        const image = product.imageIds && product.imageIds.length > 0 ?
            <Image imageId={product.imageIds[0]} size="very-small" /> :
            <Icon value={"image"} style={{ fontSize: '30px' }} />

        const title = []
        title.push(<p key={title.length} className={'m-0'} > <strong>{product.title}</strong></p>)
        if (product.sku && product.type !== PRODUCT_TYPE.BUNDLE) {
            title.push(<p key={title.length} className={'m-0'}>
                <small>{product.sku}</small>
            </p>)
        }
        if (Settings.get(SupportedSettings.ShowShortDescriptionInListing) || product.type === PRODUCT_TYPE.BUNDLE) {
            title.push(<small key={title.length} className={'m-0 add-item-trunc-long-text'}>
                {product.shortDescription}
            </small>)
        }
        const rows = [
            image,
            title,
            !this.state.stockDocument ?
                <PriceListingLabel value={product} isPriceLevelSelected={this.props.isPriceLevelSelected} /> :
                <CostListingLabel item={product} stockDocument={this.state.stockDocument} />
        ]
        if (this.state.inventoryEnabled || this.qmInventoryEnabled() || this.state.stockDocument) {
            if (!product.isNonInventory) {
                let inventoryQuantity, remoteQuantity, userInStockLocation
                if (this.qmInventoryEnabled() && !this.state.stockDocument && !this.state.inventoryEnabled) {
                    let location = AppContext.getUserLoggedIn().attributes.location
                    let inventoryLocationId = ""
                    if (this.props.documentInventoryLocations.length > 0 && location) {
                        const inventoryLocation = getInventoryLocationFromLocation(location.id, this.props.documentInventoryLocations)
                        if (inventoryLocation !== null) {
                            inventoryLocationId = inventoryLocation.id
                            userInStockLocation = true
                        }
                    }
                    if (inventoryLocationId !== "") {
                        inventoryQuantity = getQuantityAvailableByInventoryLocationId(product, inventoryLocationId)
                        remoteQuantity = getRemoteQuantityAvailableByInventoryLocationId(product, inventoryLocationId)
                    } else {
                        userInStockLocation = false
                        inventoryQuantity = 0
                        remoteQuantity = getRemoteQuantityAvailableByInventoryLocationId(product, "")
                    }

                }
                else if (this.state.stockDocument) {
                    userInStockLocation = true
                    inventoryQuantity = getQuantityAvailableByInventoryLocationId(product, this.state.stockDocument.inventoryLocationId)
                    remoteQuantity = getRemoteQuantityAvailableByInventoryLocationId(product, this.state.stockDocument.inventoryLocationId)
                } else {
                    userInStockLocation = true
                    inventoryQuantity = product.type === PRODUCT_TYPE.BUNDLE ? GlobalHelper.getQuantityOnHand(product) : GlobalHelper.getQuantityOnHand(product, this.state.location)
                    remoteQuantity = GlobalHelper.getRemoteQuantityOnHand(product, this.state.location)
                }
                rows.push(<div>
                    <div> {userInStockLocation &&
                        <FormattedMessage
                            id="add_item_modal.products.list.current_inventory_label"
                            defaultMessage="{icon} {quantity}"
                            values={{
                                icon: <Icon value={"map-marker-alt"} />,
                                quantity: inventoryQuantity,
                            }}
                        />
                    }
                    </div>
                    {AppContext.isMultiLocation() && (!this.qmInventoryEnabled() || !userInStockLocation || this.props.documentInventoryLocations.length > 1) && <div>
                        <small>
                            <FormattedMessage
                                id="add_item_modal.products.list.remote_inventory_label"
                                defaultMessage="{icon} {remoteQuantity}"
                                values={{
                                    icon: <Icon value={"store-alt"} />,
                                    remoteQuantity: remoteQuantity,
                                }}
                            />
                        </small>
                    </div>}
                </div>)
            } else {
                rows.push(<div></div>)
            }
        }
        rows.push(<button title={'Add ' + product.title} onClick={this.addProduct(product.id)} className="btn btn-outline-primary btn-item-add-product padding-left-0-for-inner-span">
            <Icon value={"plus-circle"} />
        </button>)
        return {
            metadata: {
                productId: product.id,
                productObject: product
            },
            data: rows,
            rowId: product.id,
            selected: this.state.currentProductIds.includes(product.id),
        }
    }

    render() {
        return <StandardList
            className="row pt-3 py-1 px-3"
            headers={this.state.headers}
            smallLine={true}
            rows={this.state.rows}
            tableClassName={'table-hover'}
            onRowClick={metadata => {
                this.props.onProductClick(metadata.productId)
                this.props.addProductCallback(metadata.productId)
            }}
            onRowSelect={(productId, isChecked) => {
                this.props.onProductSelect(productId)
            }}
            onPageSelect={(selection) => {
                const productIds = Object.entries(selection).filter(([key, value]) => value).map(p => p[0])
                this.props.onProductPageSelect(productIds)
            }}
            onSelectAll={allSelected => {
                this.props.onProductSelectAll(allSelected)
            }}
            selectable={this.state.selectable}
            totalItemsCount={this.state.totalItemsCount}
            pageSize={this.state.pageSize}
            bulkActions={{
                'add-products': <span >
                    <Icon value={'plus'} className={'mr-2'} />
                    <FormattedMessage
                        id="add_item_modal.products.list.bulk_action_label"
                        defaultMessage="Add selected products"
                    />
                </span>,
            }}
            customBulkAction={(selection, isEverythingSelected) => {
                const productIds = Object.entries(selection).filter(([key, value]) => value).map(p => p[0])
                this.props.onAddMultipleProducts(productIds, '')
            }}
        />;
    }
}

const mapState = (state, props) => {
    return {
        ...props,
        documentInventoryLocations: InventoryLocationSelector.getListing(state),
    }
}

const mapDispatch = (dispatch) => {
    return {
        dispatch: dispatch
    }
}
export default connect(mapState, mapDispatch)(injectIntl(ModalSearchProductList))





// WEBPACK FOOTER //
// ./src/common/pricing/add-item-modal/productList.component.jsx